<template>
  <div id="cfm_tips">
    <el-dialog
      title="确认交易"
      :visible.sync="cfmVisible"
      width="447"
      :before-close="handleClose"
    >
      <div class="body_content">
        <!-- <div>
          温馨提示：请核对订单无误后，再确认交易。
        </div> -->
        <div class="content_text" style="color:#EC212D;">
          <el-radio v-model="radio" style="margin-right: 0;" label="" />
          <span style="margin-right:50px;">
            当前可用额度：{{ data.availableAmount }}
          </span>
          <span>
            账期：{{ data.accountPeriod / 30 }}个月
          </span>
        </div>
        <div style="margin-left: 30px;" class="content_text">
          您的付款日：每月{{ fPaymentDay }}日 法定节假日可顺延
        </div>
        <div style="color:rgb(55 111 218);" class="content_text">
          请核对订单无误后再确认！
        </div>
        <!-- <div class="money-box">
          <div style="width: 48%;">
            <div style="font-size: 24px;color: #EC212D;min-height:35px;line-height:1;">
              ￥{{ data.availableAmount }}
            </div>
            <div style="padding-left:27px;">
              当前可用额度：
            </div>
          </div>
          <div>
            <div style="color: #EC212D;min-height:35px;">
              每月{{ data.accountPeriod }}日法定节假日可顺延
            </div>
            <div style="text-align: center;">
              您的付款日：
            </div>
          </div>
        </div> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="close_btn" @click="handleClose">取 消</el-button>
        <el-button class="confirm_btn" type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import service from '@/utils/request'
export default {
  props: {
    cfmVisible: {
      type: [Boolean]
    },
    selectOrderFid: {
      type: [Number, String],
      default: () => []
    }
  },
  data() {
    return {
      radio: '',
      data: {
        accountPeriod: '',
        availableAmount: ''
      },
      fPaymentDay: ''
    }
  },
  watch: {
    cfmVisible(val) {
      if (val) {
        service({
          url: '/mall/mallmanage/demandOrder/queryReceivingAddr',
          method: 'post'
        })
          .then(res => {
            this.data = res.data.paymentTypeList[0]
            this.fPaymentDay = res.data.fPaymentDay
          })
      }
    }
  },
  methods: {
    handleClose() {
      this.$router.push({
        path: '/order/orderManagement'
      })
      this.$emit('cfmSwitch', false)
    },
    confirm() {
      const fnoList = [{
        fno: this.selectOrderFid
      }]
      const data = new URLSearchParams()
      data.append('jsonobj', JSON.stringify({ fnoList }))
      service({
        url: '/mall/mallmanage/demandOrder/confirmOrder',
        method: 'post',
        data
      })
        .then(res => {
          if (res.result) {
            this.$message.success(res.msg)
            this.handleClose()
          } else {
            this.$message.error(res.msg)
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
#cfm_tips {
    .body_content {
        height: 240px;
        // border-bottom: 1px solid #C4CBD7;
        padding: 28px 30px 0;
        font-size: 16px;
        .money-box {
            display: flex;
            margin-top: 30px;
        }
        .content_text {
            height: 50px;
        }
    }
    .dialog-footer {
        .close_btn {
            border: 1px solid #C4CBD7;
            color: #C4CBD7;
        }
    }
}
</style>
<style lang="scss">
#cfm_tips {
    .el-dialog {
        position: relative;
        top: 45% !important;
        width: 576px !important;
        height: 280px !important;
        border-radius: 10px;
    }
    .el-dialog__header {
        height: 40px;
        font-size: 16px;
        padding-left: 23px;
        border-radius: 10px 10px 0 0;
        text-align: center;
    }
    .el-dialog__body {
        height: 184px !important;
        padding: 0;
    }
    .el-dialog__footer {
        padding: 10px;
        text-align: center;
    }
    .dialog-footer {
        .el-button {
            width: 80px;
            height: 36px;
        }
    }
}
</style>
